import VideoPlayer from 'components/ui-builder/common/video-player'
import AccountVideoPlayer from 'components/ui/video-player'
import React from 'react'

/**
 * A React component for rendering optimised videos with various features.
 *
 * This component provides advanced video rendering capabilities,
 * responsive sizing and video optimization.
 *
 * @param {object} props - The properties for the CdnVideo component.
 * @param {string} props.url - The URL of the video to be displayed.
 * @param {string} [props.width=''] - The width of the video.
 * @param {boolean} [props.isAccount=''] - Account videos use the components ui video player. Default is false
 * @returns {React.ReactElement} The rendered video element.
 */
const CdnVideo = ({
  videoSrc,
  videoShouldLoop,
  imageSrc,
  playbackSettings,
  width,
  isAccount = false
}: {
  videoSrc: string
  videoShouldLoop: boolean
  imageSrc?: string
  playbackSettings?: any
  width?: number
  isAccount: boolean
}): React.ReactElement => {
  // not compatible with iOS
  // const basePath = `https://cdn.differentdog.com/video`
  // const sourceUrl = width ? `${basePath}/width=${width}/${videoSrc}` : `${videoSrc}`
  const sourceUrl = videoSrc

  return (
    <>
      {isAccount ? (
        <AccountVideoPlayer videoLoop={videoShouldLoop} videoSrc={sourceUrl} />
      ) : (
        <VideoPlayer
          videoLoop={videoShouldLoop}
          videoSrc={sourceUrl}
          imageSrc={imageSrc}
          playbackSettings={playbackSettings}
        />
      )}
    </>
  )
}

export default CdnVideo
